import { InputNumber } from 'antd';
import { ComponentProps } from 'react';
import { useDecimalInputProps } from './DecimalInput';

// A percent never reaches a thousand, so any lone separator is the decimal point.
export const usePercentInputProps = ({ precision }: { precision: number }) => useDecimalInputProps({ precision });

type PercentInputProps = ComponentProps<typeof InputNumber<number>> & { precision?: number };

const PercentInput = ({ precision = 2, ...props }: PercentInputProps) => {
  const percentProps = usePercentInputProps({ precision });
  return <InputNumber<number> min={0} max={100} {...percentProps} {...props} />;
};

export default PercentInput;
